/** 2:1 isometric projection — grid (gx, gz) → screen (x, y), +Y down. */

const TILE_W = 36;
const TILE_H = 18;

export function isoToScreen(gx: number, gz: number): { x: number; y: number } {
	return {
		x: (gx - gz) * TILE_W,
		y: (gx + gz) * TILE_H,
	};
}

/** Painter's order: farther buildings first (smaller gx+gz typically back — tune: sort by gx+gz ascending draws back-to-front for standard iso) */
export function depthKey(gx: number, gz: number): number {
	return gx + gz;
}
